export default __webpack_public_path__ + "static/media/seaweed_2.dcc6277b.jpg";